import { render, staticRenderFns } from "./ProductKitItemSidebar.vue?vue&type=template&id=78959880&"
import script from "./ProductKitItemSidebar.vue?vue&type=script&lang=js&"
export * from "./ProductKitItemSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78959880')) {
      api.createRecord('78959880', component.options)
    } else {
      api.reload('78959880', component.options)
    }
    module.hot.accept("./ProductKitItemSidebar.vue?vue&type=template&id=78959880&", function () {
      api.rerender('78959880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product-kit/ProductKitItemSidebar.vue"
export default component.exports